export default __webpack_public_path__ + "static/media/bm.d3f55ba9.svg";